import { render, staticRenderFns } from "./MenuUS.vue?vue&type=template&id=f922f8b4&scoped=true&"
import script from "./MenuUS.vue?vue&type=script&lang=js&"
export * from "./MenuUS.vue?vue&type=script&lang=js&"
import style0 from "./MenuUS.vue?vue&type=style&index=0&id=f922f8b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f922f8b4",
  null
  
)

export default component.exports